// extracted by mini-css-extract-plugin
export default {"contentWrapper":"layout_contentWrapper__Usg2U","content":"layout_content__-05v8","wrapper":"layout_wrapper__MK4h4"};